"use client"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import CopyLinkButton from "@src/components/CopyLinkButton"
import Icons from "@src/components/Icons"
import LikeIcon from "@src/components/BlogCard/LikeIcon"
import dayjs from "dayjs"
import DangerouslySetInnerHTML from "@src/components/DangerouslySetInnerHTML"

interface Props {
  collectionId: number
  slug: string
  title?: string
  description?: string
  likes?: number
  publish_date: string
  author_name: string
}

const TitleSection = (props: Props) => {
  const { collectionId, slug, title = "", description, likes = 0, publish_date, author_name } = props || {}
  return (
    <Box width="100%">
      <Typography
        fontSize={{
          xs: "20px",
          md: "48px"
        }}
        fontWeight={700}
        lineHeight={{
          xs: "30px",
          md: "64px"
        }}
        mb={{
          xs: "16px",
          md: "24px"
        }}
        textAlign={{
          xs: "center",
          md: "left"
        }}
      >
        <DangerouslySetInnerHTML html={title} />
      </Typography>
      <Stack justifyContent="space-between" alignItems="center" direction="row" flexWrap="wrap">
        <Stack direction="row" gap="8px">
          <Typography
            className="truncate-1"
            variant="body2"
            color="#7D7D7D"
            component="span"
            display="inline-block"
            sx={{
              width: {
                xs: "50%",
                md: "auto"
              }
            }}
          >
            {author_name}
          </Typography>
          <Typography color="#7D7D7D">|</Typography>
          <Typography
            className="truncate-1"
            variant="body2"
            color="#7D7D7D"
            component="span"
            display="inline-block"
            sx={{
              width: {
                xs: "50%",
                md: "auto"
              }
            }}
          >
            {`Ngày đăng: ${publish_date ? (
              dayjs(publish_date).format("DD/MM/YYYY")
            ) : null}`}
          </Typography>

        </Stack>
        <Stack direction="row" gap="16px">
          <CopyLinkButton
            url={`${process.env.NEXT_PUBLIC_BASE_URL}/blogs/${slug}`}
          />

          <Stack direction="row" gap="8px" alignItems="center">
            <LikeIcon collectionId={collectionId} slug={slug} />
            <Typography as="span">{likes}</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>

  )
}

export default TitleSection